import React from 'react';
import PropTypes from 'prop-types';
import noop from '../../../../core/modules/common/tools/noop';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';
import OnlySelectedFilterCheckbox from '../../../common/components/OnlySelectedFilterCheckbox';

const PostalOperatorSelector = (props) => {
  const {
    title = '',
    selected = [],
    expanded = [],
    expandDisabled = false,
    onSelect = noop,
    onExpand = noop,
    onSelectAll = noop,
    onDeSelectAll = noop,
    isShowOnlySelected = false,
    onShowOnlySelected = noop,
    operatorUserNodes = [],
    originalOperatorUserNodes = [],
  } = props;

  return (
    <div className="operator-selector-container">
      {operatorUserNodes.length ?
        <CheckboxTreeSelector
          title={title}
          nodes={operatorUserNodes}
          selected={selected}
          expanded={expanded}
          expandDisabled={expandDisabled}
          onSelect={onSelect}
          onExpand={onExpand}
          onSelectAll={onSelectAll}
          onDeSelectAll={onDeSelectAll}
          originalNodes={originalOperatorUserNodes}
        /> : <div />
      }

      <div className="operator-selector-footer">
        <OnlySelectedFilterCheckbox
          isShowOnlySelected={isShowOnlySelected}
          onShowOnlySelected={onShowOnlySelected}
          isDisabled={selected.length === 0}
        />
      </div>
    </div>
  );
};

PostalOperatorSelector.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.string),
  expanded: PropTypes.arrayOf(PropTypes.string),
  expandDisabled: PropTypes.bool,
  onSelect: PropTypes.func,
  onExpand: PropTypes.func,
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  operatorUserNodes: PropTypes.arrayOf(PropTypes.object),
  originalOperatorUserNodes: PropTypes.arrayOf(PropTypes.object),
  isShowOnlySelected: PropTypes.bool,
  onShowOnlySelected: PropTypes.func,
};

export default PostalOperatorSelector;
